import HoldingSettlementPage from './HoldingSettlementPage';
import HoldingSettlementsList from '../../components/HoldingSettlement/HoldingSettlementsList';

const HoldingSettlements = () => (
    <HoldingSettlementPage
        title="Holding Settlements"
        breadcrumbTitle="Holding Settlements"
    >
        <HoldingSettlementsList />
    </HoldingSettlementPage>
);

export default HoldingSettlements;
